import { render, staticRenderFns } from "./popUpForm.vue?vue&type=template&id=93c4cab0&scoped=true"
import script from "./popUpForm.vue?vue&type=script&lang=js"
export * from "./popUpForm.vue?vue&type=script&lang=js"
import style0 from "./popUpForm.vue?vue&type=style&index=0&id=93c4cab0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c4cab0",
  null
  
)

export default component.exports